/** formatCustomerType — human-readable label for persona customer type codes. */

const LABELS: Record<string, string> = {
  RESIDENTIAL: "Residential",
  COMMERCIAL_SMALL: "Small Commercial",
  COMMERCIAL_LARGE: "Large Commercial",
  PROPERTY_MANAGER: "Property Manager",
};

export function formatCustomerType(type: string): string {
  return LABELS[type] ?? type;
}
